import VuexPersistence from 'vuex-persist';

import { logger } from '@/tools';
// custom Plugins
import viewportInformation from './viewportInformation';
import styleDevListener from './styleDevListener';
import viewStateHandler from './viewStateHandler';
import inactivityDetector from './inactivityDetector';
import nativeContentListener from './nativeContentListener';
import loanerDeviceListener from './loanerDeviceListener';

const plugins = [
	styleDevListener,
	viewportInformation,
	viewStateHandler,
	inactivityDetector,
	nativeContentListener,
	loanerDeviceListener,
];

// vuex-presist can not be used if the webclient is used in an iframe and
// third party cookies are disabled. Therefore this needs to be conditional.
let vuexLocal;
try {
	vuexLocal = new VuexPersistence({
		storage: window.sessionStorage,
		reducer: state => ({ persistent: state.persistent }),
		// filter: mutation => mutation.type === 'setRole', only update on filtered mutations
	});
	plugins.push(vuexLocal.plugin);
} catch (error) {
	logger.error(`It is not possible to use vuex-persist: ${error}`);
}

export default plugins;
